<template>
  <crud-table :config="config"></crud-table>
</template>

<script>
//importare e registrare qui tutti i componenti child della tabella.(non in crudTableHeader/crudTableRow)
//NB : le operazioni crud a livello di database vanno collocate  direttamente nel componente child
import { ref } from "@/components/puntatori";
import { EventBus } from "../main.js";
import Vue from "vue";
import crudTable from "@/components/crudTable";
Vue.component("crud-table", crudTable);

export default {
  name: "crudTableListino",
  data() {
    return {
      config: {
        tableRowsData: [],
        tableType: "table",
        //la variabile tableConfig deve essere SEMPRE dichiarata come 'prop' nei child del componente crudTable***
        source: 'listini',
        tableColumns: [
          //{ title: "Titolo", style: "width:100px" },
          { string: "Titolo" ,style: "color:red;width:30%"} ,
          { string: "Regole",style: "width:35%" },
          { string: "Scadenza" ,style: "width:25%"},
          { string: "Azioni" ,style: "width:25%" }
        ],
        tableRowsConfig: [
          //{ html: "<h1>prova html</h1>" }, // codice html
          //{ string: "titolo" },  //nome della key del nodo firebase
          //{ componentName: "crudTableActionButton" } //il nome del componente registrato
          //quando le cose si fanno più complicate di una semplice string o img o tag html fare componente
          { string: "titolo",style: "width:10%" },
          { string: "regole" ,style: "width:35%"},
          { string: "scadenza" ,style: "width:25%"},
          { componentName: "crudTableActionButton" ,style: "width:25%" } //il nome del componente registrato
        ],
        gridItemConfig: [
          //{ html: "<h1>prova html</h1>" }, // codice html
          //{ string: "titolo" },  //nome della key del nodo firebase
          //{ componentName: "crudTableActionButton" } //il nome del componente registrato
          //quando le cose si fanno più complicate di una semplice string o img o tag html fare componente
          { html: "<h1>CIAO</h1>", style: "color:red" },
          // { string: "regole" },
          { string: "scadenza" },
          { componentName: "crudTableActionButton" } //il nome del componente registrato
        ]
      }
    };
  },
  computed: {},
  methods: {},
  mounted() {
    
  },
  watch: {
    $route() {}
  }
};
</script>

<style scoped>
.prova {
  color: red;
}

main table {
  width: 110% !important;
}

main .table-striped tbody tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

main .table-striped tbody tr {
  background-color: white;
  cursor: pointer;
}

main .table-striped tbody tr:hover {
  background-color: #f5f5f5;
}

/* STYLE PER VISUALIZZAZIONE A  GRID*/
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15vw, 18vw));
  list-style-type: none;
  padding: 0px;
  margin: 0px;
  grid-auto-rows: minmax(auto, 20vw);
  grid-gap: 25px;
}
.grid-item {
  transition: left 300ms, top 300ms;
  background-color: white;
  border-radius: 10px;
  border: solid 3px #f9f9f9;
  font-size: 14px;
}
</style>
